import { formatToLocaleNumber } from "src/utils";
import { TrendAlertItem } from "./types";

export const getTrackerName = (name: string) => {
  const idx = name.indexOf("-");
  return idx !== -1 ? name.slice(0, idx).trim() : name;
};

export const filterAlertsByType = (
  alerts: TrendAlert.Data[],
  alertGroup: "volume" | "newData",
): TrendAlert.Data[] => {
  return alerts.filter((alert) => {
    if (alertGroup === "volume") {
      return ["consistent", "oneTime"].includes(alert.type);
    }

    return ["suggestions"].includes(alert.type);
  });
};

// Partition alerts into volume and suggestions
export const partitionAlerts = (alerts: TrendAlert.Data[]) => {
  const volumeAlerts: TrendAlert.Data[] = [];
  const newDataAlerts: TrendAlert.Data[] = [];

  alerts.forEach((alert) => {
    if (["consistent", "oneTime"].includes(alert.type)) {
      volumeAlerts.push(alert);
    } else {
      newDataAlerts.push(alert);
    }
  });

  return { volumeAlerts, newDataAlerts };
};

// Format volume value for display
export const formatVolumeDisplay = (
  volume: number | null,
  type: TrendAlert.Type,
  percentage?: string,
): string => {
  if (volume === null) return "-";

  const formatted = formatToLocaleNumber(volume);
  if (type === "consistent" && percentage) {
    return `${formatted} (${percentage}%)`;
  }
  return formatted;
};

// Transform TrendAlert.Data to ModalTrendAlertItem
export const transformAlertToModalItem = (
  alert: TrendAlert.Data,
): TrendAlertItem => {
  return {
    id: alert.id,
    name: alert.trackerName,
    minVolume: alert.minVolume || null,
    percentage: alert.percentage || "",
    condition: alert.condition || "",
    currentVolume: alert.currentVolume || alert.baseVolume || null,
    targetVolume: alert.targetVolume || null,
    type: alert.type || "consistent",
    updatedAt: alert.updatedAt || "",
  };
};

// Transform array of TrendAlert.Data to ModalTrendAlertItem[]
export const transformAlertsToModalItems = (
  alerts: TrendAlert.Data[],
): TrendAlertItem[] => {
  return alerts.map(transformAlertToModalItem);
};
